const VOUCHER_THEME_TITLE_COLOUR_MAP: Partial<Record<App.VoucherTheme, App.Design.ContentColour>> = {
  luxplus: 'lux-plus',
  societe: 'normal-contrast',
  'societe-bronze': 'normal-contrast',
  'societe-silver': 'normal-contrast',
  'societe-gold': 'normal-contrast',
  'societe-platinum': 'normal-contrast',
}

export default function getVoucherTitleColour(theme?: App.VoucherTheme): App.Design.ContentColour {
  const titleColour = theme ? VOUCHER_THEME_TITLE_COLOUR_MAP[theme] : undefined

  return titleColour ?? 'light-foreground-alt'
}
